import * as types from "../constants/actionTypes";

export const setCheckinDate = date => {
  return {
    type: types.CHECKIN_DATE,
    payload: date
  };
};

export const setCheckoutDate = date => {
  return {
    type: types.CHECKOUT_DATE,
    payload: date
  };
};

export const setIsFlexibleDates = val => {
  return {
    type: types.FLEXIBLE_DATES,
    payload: val
  };
};



// WEBPACK FOOTER //
// ./src/actions/datesActions.js